import type { PixelSprite } from '../types.js';
import { sprites as alpineRocks } from './alpineRocks.js';
import { sprites as beachTowel } from './beachTowel.js';
import { sprites as boulder } from './boulder.js';
import { sprites as bush } from './bush.js';
import { sprites as cattail } from './cattail.js';
import { sprites as driftwood } from './driftwood.js';
import { sprites as flower } from './flower.js';
import { sprites as frog } from './frog.js';
import { sprites as heron } from './heron.js';
import { sprites as lily } from './lily.js';
import { sprites as parasol } from './parasol.js';
import { sprites as rock } from './rock.js';
import { sprites as sandcastle } from './sandcastle.js';
import { sprites as sandcastleSummer } from './sandcastleSummer.js';
import { sprites as shellfish } from './shellfish.js';
import { sprites as snowCoveredRock } from './snowCoveredRock.js';
import { sprites as surfboard } from './surfboard.js';
import { sprites as tidePools } from './tidePools.js';
export const sprites: Readonly<Record<string, readonly PixelSprite[]>> = {
  alpineRocks,
  beachTowel,
  boulder,
  bush,
  cattail,
  driftwood,
  flower,
  frog,
  heron,
  lily,
  parasol,
  rock,
  sandcastle,
  sandcastleSummer,
  shellfish,
  snowCoveredRock,
  surfboard,
  tidePools,
};
